import React from 'react';
import './Day1.css';
import Footer from '../Footer/Footer';

function Day3() {
  return (
    <div className='day1'>
      <div className='prog_header'>
        <h1 className='prog_header_kippra'>6TH KIPPRA ANNUAL REGIONAL CONFERENCE</h1>
        <h1 className='prog_header_theme'>THEME: ACCELERATING ECONOMIC GROWTH AND DEVELOPMENT FOR ASALS IN </h1>
        <h1 className='prog_header_theme'>KENYA</h1>
      </div>
      <div>
        <table>
          <thead>
            <tr>
              <th colSpan="3"><span style={{ fontWeight: '600', textDecoration: 'underline' }}>DAY 3: </span> 23rd JUNE 2023</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td style={{ fontWeight: "bold" }}>7.00 – 8.00</td>
              <td></td>
              <td>KIPPRA DOCUMENTARY</td>
            </tr>
            <tr>
              <td style={{ fontWeight: "bold" }}>8.00 – 8.10</td>
              <td></td>
              <td>PRAYERS</td>
            </tr>
            <tr>
              <td style={{ fontWeight: "bold" }}>8.10 – 8.30 </td>
              <td></td>
              <td>RECAP OF DAY TWO: <span style={{ fontStyle: "italic" }}>Key Highlights</span></td>
            </tr>
          </tbody>
          <thead>
            <tr>
              <th style={{ fontWeight: '600' }} colSpan="3">THEME 6: NATURAL RESOURCES AND AGRICULTURE IN ASALS</th>
            </tr>
          </thead>
          <thead>
            <tr>
              <th style={{ fontWeight: 'bold', backgroundColor: "white", color: "black" }} colSpan="3">PLENARY SESSION 6.1- Natural Resources and Agriculture in ASALs </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td style={{ fontWeight: "bold" }}>8.30 - 9.30</td>
              <td>Venue- <br />
                      <span style={{fontWeight: "bold"}}>Main Tent</span>
                            </td>
              <td style={{ fontWeight: "normal" }}>Commercializing Sporting Activities and Performing Arts in ASALs<br /><br />
              <span style={{fontStyle: "italic", fontWeight: "400"}}>Plenary (20 Minutes)</span>
               
              </td>
              
            </tr>
            <tr>
              <td style={{ fontWeight: "bold" }}>9.30 - 10.30</td>
              <td>Venue- <br />
                     <span style={{fontWeight: "bold"}}>Main Tent</span> 
                            </td>
              <td style={{ fontWeight: "normal" }}>Exploiting opportunities in Culture, Heritage, Archaeological Sites, and Museums for Economic Growth<br /><br />
              <span style={{fontStyle: "italic", fontWeight: "400"}}>Plenary (20 Minutes)</span>
               
              </td>
              
            </tr>
            <tr>
              <td style={{ fontWeight: "bold" }}>9.30 - 10.30</td>
              <td>Venue- <br />
                    <span style={{fontWeight: "bold"}}>Tent A</span>
                            </td>
              <td style={{ fontWeight: "normal" }}>Blue Economy <br /><br />
              <span style={{fontStyle: "italic", fontWeight: "400"}}>Plenary (20 Minutes)</span>
               
              </td>
              
            </tr>
            <tr>
              <td style={{ fontWeight: "bold" }}>9.30 - 10.30</td>
              <td>Venue- <br />
                    <span style={{fontWeight: "bold"}}>Tent B</span>
                            </td>
              <td style={{ fontWeight: "normal" }}>Wildlife Conservancies, building sustainable partnerships <br /><br />
              <span style={{fontStyle: "italic", fontWeight: "400"}}>Plenary (20 Minutes)</span>
               
              </td>
              
            </tr>
            <tr>
              <td style={{ fontWeight: "bold" }}>10.30 – 11.00</td>
              <td></td>
              <td style={{ fontWeight: "bold" }}>REFRESHMENT AND ENTERTAINMENT</td>
            </tr>
            <tr>
              <td style={{ fontWeight: "bold" }}>11.00 - 12.00</td>
              <td>Common session <br />
                    <span style={{fontWeight: "bold"}}>Main Tent</span>
                            </td>
              <td style={{ fontWeight: "normal" }}>Official Data Systems  <br /><br />
              <span style={{fontStyle: "italic", fontWeight: "400"}}>Plenary (20 Minutes)</span>
               
              </td>
              
            </tr>
            <tr>
              <td style={{ fontWeight: "bold" }}>12.00 - 13.00</td>
              <td>venue- <br />
                    <span style={{fontWeight: "bold"}}>Main Tent</span>
                            </td>
              <td style={{ fontWeight: "normal" }}>Livestock, Poultry and Apiculture in ASALs: Opportunities to Harness   <br /><br />
              <span style={{fontStyle: "italic", fontWeight: "400"}}>Plenary (20 Minutes)</span>
               
              </td>
              
            </tr>
            <tr>
              <td style={{ fontWeight: "bold" }}>12.00 - 13.00</td>
              <td>venue- <br />
                    <span style={{fontWeight: "bold"}}>Tent A</span>
                            </td>
              <td style={{ fontWeight: "normal" }}>Extractive Economy in ASALs (Minerals, Oil, Gums, Resins)    <br /><br />
              <span style={{fontStyle: "italic", fontWeight: "400"}}>Plenary (20 Minutes)</span>
               
              </td>
              
            </tr>
            <tr>
              <td style={{ fontWeight: "bold" }}>12.00 - 13.00</td>
              <td>venue- <br />
                    <span style={{fontWeight: "bold"}}>Tent B</span>
                            </td>
              <td style={{ fontWeight: "normal" }}>Inclusivity of PWDs and Gender Dynamics  
 in ASALs 
 <br /><br />
              <span style={{fontStyle: "italic", fontWeight: "400"}}>Plenary (20 Minutes)</span><br />
               
              </td>
              
            </tr>
            <tr>
              <td style={{ fontWeight: "bold" }}></td>
              <td>
                   
                            </td>
              <td style={{ fontWeight: "600" }}>Plenary (20 minutes) <br />
              
              <span style={{color:"rgb(16, 187, 16)", fontStyle: "italic", fontWeight:"bold"}}>Interlude with short video clip </span> <span style={{fontWeight: "400", color: "black"}}>(2 Minutes)</span>
              </td>
              
            </tr>
            <tr>
              <td style={{ fontWeight: "bold" }}>13.00 – 14.00</td>
              <td></td>
              <td style={{ fontWeight: "bold" }}>LUNCH AND ENTERTAINMENT</td>
            </tr>
            <tr>
              <td style={{ fontWeight: "bold" }}>14.00 - 14.30</td>
              <td>Common session <br />
                    <span style={{fontWeight: "bold"}}>Main Tent</span>
                            </td>
              <td style={{ fontWeight: "normal" }}>Role of think tanks in promoting growth of ASALS in Kenya (southern voice)  <br />
              
               
              </td>
              
            </tr>
          </tbody>
          <thead>
            <tr>
              <th style={{ fontWeight: '600' }} colSpan="3">THEME 7: TRADE AND FINANCE</th>
            </tr>
          </thead>
          <thead>
            <tr>
              <th style={{ fontWeight: 'bold', backgroundColor: "white", color: "black" }} colSpan="3">PLENARY SESSION 7.1 – Role of Trade and Finance in ASALS economic Growth </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td style={{ fontWeight: "bold" }}>14.30 - 15.15</td>
              <td>venue- <br />
                    <span style={{fontWeight: "bold"}}> Main Tent</span>
                            </td>
              <td style={{ fontWeight: "normal" }}>Financial Inclusion<br /> <br />

              <span style={{fontStyle: "italic", fontWeight: "400"}}>Plenary (10 Minutes)</span><br />
              </td>
            </tr>
            <tr>
              <td style={{ fontWeight: "bold" }}>14.30 - 15.15</td>
              <td>venue- <br />
                    <span style={{fontWeight: "bold"}}>Tent A</span>
                            </td>
              <td style={{ fontWeight: "normal" }}>Cross Border Trading in ASALs <br /> <br />

              <span style={{fontStyle: "italic", fontWeight: "400"}}>Plenary (10 Minutes)</span><br />
              </td>
            </tr>
            <tr>
              <td style={{ fontWeight: "bold" }}>14.30 - 15.15</td>
              <td>venue- <br />
                    <span style={{fontWeight: "bold"}}>Tent B</span>
                            </td>
              <td style={{ fontWeight: "normal" }}>Trade Financing in ASALs  <br /> <br />

              <span style={{fontStyle: "italic", fontWeight: "400"}}>Plenary (10 Minutes)</span><br />
              </td>
            </tr>
            <tr>
              <td style={{ fontWeight: "bold" }}>15.15 - 16.15</td>
              <td>Common session <br />
                    <span style={{fontWeight: "bold"}}>Main Tent</span>
                            </td>
              <td style={{ fontWeight: "normal" }}>Irrigated Agriculture to secure Food and nutrition Security  <br />
              
               
              </td>
              
            </tr>
            <tr>
              <td style={{ fontWeight: "bold" }}>16.15 - 17.00</td>
              <td>
                   
                            </td>
              <td style={{ fontWeight: "bold" }}>SPECIAL SESSION 2 – WRAP UP AND WAY FORWARD <br />

              </td>
              
            </tr>
          </tbody>
      
         
       
          <tbody>
           
           
            <tr>
              <td style={{ fontWeight: "bold" }}></td>
              <td style={{fontStyle: "italic"}}>SS2_1</td>
              <td style={{ fontWeight: "normal" }}>
              Conference Resolutions - Presentation of Conference Communique <br /> <br />
              </td>
            </tr>
            <tr>
              <td style={{ fontWeight: "bold" }}></td>
              <td style={{fontStyle: "italic"}}>SS2_2</td>
              <td style={{ fontWeight: "normal" }}>
              Vote of Thanks  <br /> <br />
              </td>
            </tr>
            <tr>
              <td style={{ fontWeight: "bold" }}></td>
              <td style={{fontStyle: "italic"}}>SS2_3</td>
              <td style={{ fontWeight: "normal" }}>
              Closing Remarks  <br /> <br />
              </td>
            </tr>
            <tr>
              <td style={{ fontWeight: "bold" }}></td>
              <td style={{fontStyle: "italic"}}>SS2_4</td>
              <td style={{ fontWeight: "normal" }}>
              Official Closing Statement <br /> <br />
              </td>
            </tr>
            <tr>
              <td style={{ fontWeight: "bold" }}>17.15</td>
              <td></td>
              <td >
              <span style={{ fontWeight: "bold" }}>Refreshment and Entertainment</span> <br /> <br />
                <span style={{ fontWeight: "bold" }}>VISTORS LEAVE AT THEIR OWN PLEASURE</span></td>
            </tr>
          </tbody>
        </table>
      </div>
      <div style={{ marginTop: "20px" }}>
        <Footer />
      </div>
    </div>
  )
}

export default Day3;
